import {GETSETTINGS} from '../actions/constant';

const INITIAL_STATE = {
    setting: {}
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type){
        case GETSETTINGS:
            return {...state, setting:action.payload.data};
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_settings.js